

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupMaster } from "@/data/models/ClientSetup";
import { PARTNER_SYSTEM_CHOICES } from "@/data/models/ClientPartner";
import { partnerSystemLabelKey } from "@/utils/ClientPartners";
import { ClientSetupDraft, followsMaster, setupExternalSystemEmail, setupExternalSystemErrors } from "@/utils/ClientSetupDraft";

const PARTNERS = "admin.clients.partners";

@Component
export default class SetupExternalSystemsStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  /** A member's master with its systems; null otherwise or while loading. */
  @Prop({ default: null }) master!: ClientSetupMaster | null;
  /** Set by the page when IRES Cloud refused ANLEGEN because an account already has the address. */
  @Prop({ default: false }) emailTaken!: boolean;

  touched: Record<string, boolean> = {};

  get isMember(): boolean {
    return followsMaster(this.draft);
  }

  get masterSystems(): Array<{ id: string; name: string }> {
    return this.master?.externalSystems ?? [];
  }

  get email(): string {
    return setupExternalSystemEmail(this.draft);
  }

  get systemItems() {
    return PARTNER_SYSTEM_CHOICES.map((value) => ({ value, label: this.$t(partnerSystemLabelKey(value === "NONE" ? null : value)).toString() }));
  }

  get signInItems() {
    return (["API_KEY", "SIGN_IN"] as const).map((value) => ({ value, label: this.$t(`${PARTNERS}.signIn.${value}`).toString() }));
  }

  get emailErrors(): string[] {
    if (this.emailTaken) {
      return [this.$t("admin.clients.setup.errors.EXTERNAL_SYSTEM_EMAIL_TAKEN").toString()];
    }
    if (!setupExternalSystemErrors(this.draft).includes("email") || (!this.touched.email && this.email.trim() === "")) {
      return [];
    }
    return this.email.trim().toLowerCase() === this.draft.email.trim().toLowerCase()
      ? [this.$t("admin.clients.setup.externalSystems.sameAsClient").toString()]
      : [this.$t(`${PARTNERS}.create.emailInvalid`).toString()];
  }

  /** A name is required once the field was left; a bad Basis-URL shows at once, as in the NEU dialog. */
  errorFor(field: "name" | "baseUrl"): string[] {
    if (!setupExternalSystemErrors(this.draft).includes(field) || (field === "name" && !this.touched.name)) {
      return [];
    }
    return [this.$t(field === "name" ? "admin.clients.masterData.fieldErrors.required" : `${PARTNERS}.fieldErrors.baseUrl`).toString()];
  }

  onEmailInput(value: string) {
    this.draft.externalSystem.typedEmail = value;
  }

  touch(field: string) {
    this.$set(this.touched, field, true);
  }
}
